import React, { Component } from 'react'
import { FormControl, Select, MenuItem } from '@mui/material'
import SelectList from '@/feature/admin/Templates/select/SelectList'
import { FormInputLabel } from '@/shared/ui/input'

class BlockFormTemplateSelect extends Component {
    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
    }

    renderTemplateOptions() {
        if (!this.props.template) {
            return ''
        }
        const kedo = this.props.kedo
        let fieldNames = []
        switch (this.props.template) {
            case 'cardPerson':
                fieldNames = ['title', 'picture', 'description']
                break
            case 'cardCarousel':
                fieldNames = ['title', 'picture', 'subtitle', 'description']
                break
            case 'cardTimeline':
                fieldNames = [
                    'date',
                    'title',
                    'picture',
                    'subtitle',
                    'description',
                ]
                break
            case 'calendar':
                fieldNames = ['name', 'start', 'end', 'location']
                break
        }

        return (
            <div>
                {fieldNames.map((fieldName) => (
                    <FormControl fullWidth size="small" key={fieldName}>
                        <FormInputLabel>
                            {kedo.t(`template_${fieldName}`)}
                        </FormInputLabel>
                        <SelectList
                            currentValue={
                                this.props.templateOptions &&
                                this.props.templateOptions[fieldName]
                                    ? this.props.templateOptions[fieldName]
                                    : null
                            }
                            onClear={() =>
                                this.props.handleTemplateOptionsChange(
                                    fieldName,
                                    null
                                )
                            }
                            searchName={'search'}
                            disableInit={true}
                            kedo={kedo}
                            urlParams={{
                                environment: kedo.env().getEnvironment().id,
                                defDossier: this.props.defDossier,
                                view: this.props.view_name,
                            }}
                            onDisplayName={(item) =>
                                kedo
                                    .env()
                                    .translateItem(item, 'displayitem', true)
                            }
                            url={kedo.api().getDisplayItemEndpoint()}
                            onSelect={(item) =>
                                this.props.handleTemplateOptionsChange(
                                    fieldName,
                                    item.id
                                )
                            }
                        />
                    </FormControl>
                ))}
            </div>
        )
    }

    renderTemplates() {
        const kedo = this.props.kedo
        let options = ['default']
        if (this.props.layout === 'cards') {
            options = [
                'cardDefault',
                'cardCarousel',
                'cardPerson',
                'cardListVariant',
                'cardTimeline',
            ]
        }

        return (
            <FormControl fullWidth margin="normal">
                <FormInputLabel>{this.props.kedo.t('Template')}</FormInputLabel>
                <Select
                    value={this.props.template || ''}
                    name="template"
                    onChange={this.props.handleNormalChange}
                    size="small"
                    displayEmpty
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>

                    {options.map((template) => (
                        <MenuItem key={template} value={template}>
                            {kedo.t(`block_template_${template}`)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        )
    }

    handleChange(event) {
        if (event.target.value === 'calendar') {
            this.props.handleChangeVar('template', 'calendar')
        } else {
            this.props.handleChangeVar('template', null)
        }

        this.props.handleNormalChange(event)
    }

    render() {
        const kedo = this.props.kedo
        return (
            <div>
                <h3>{kedo.t('Template')}</h3>
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{kedo.t('Layout')}</FormInputLabel>
                    <Select
                        value={this.props.layout || ''}
                        name="layout"
                        onChange={this.handleChange}
                        size="small"
                        displayEmpty
                    >
                        <MenuItem value="">
                            {kedo.t('Choose an option')}
                        </MenuItem>

                        <MenuItem value="table">{kedo.t('Table')}</MenuItem>

                        <MenuItem value="cards">{kedo.t('Cards')}</MenuItem>

                        <MenuItem value="calendar">
                            {kedo.t('Calendar')}
                        </MenuItem>
                    </Select>
                </FormControl>
                {this.props.layout !== 'calendar'
                    ? this.renderTemplates()
                    : null}
                {this.renderTemplateOptions()}
            </div>
        )
    }
}

export default BlockFormTemplateSelect
